import { keyframes, css } from '@emotion/react';
import styled from '@emotion/styled';
import type { OverlayEffectStyleCustomizationRequest } from '@zola/svc-web-api-ts-client';
import { ZINDEX } from '@zola/zola-ui/src/styles/emotion';

const show = keyframes`
0% { 
  opacity: 0;
}

100% {
  opacity: 1;
}
`;

export const StyledOverlayWrapper = styled.div<{
  delay: number;
  isSinglePage?: boolean;
  heightPercentage: number;
  position?: OverlayEffectStyleCustomizationRequest.PositionEnum;
}>`
  z-index: ${ZINDEX.super};
  animation: ${show} ${props => props.delay}s;
  position: absolute;
  height: 100%;
  display: flex;
  flex-direction: column;
  top: ${props => (props.isSinglePage ? 0 : 'auto')};
  width: ${props => (props.isSinglePage ? '100%' : 'auto')};

  > div {
    height: ${props => props.heightPercentage}%;
  }

  ${props =>
    (props.position as unknown) === 'TOP_LEFT' &&
    css`
      left: 0;
      top: 0;
      align-items: ${props.isSinglePage ? 'flex-start' : 'auto'};
    `}

  ${props =>
    (props.position as unknown) === 'TOP_RIGHT' &&
    css`
      right: 0;
      top: 0;
      align-items: ${props.isSinglePage ? 'flex-end' : 'auto'};
    `}

  ${props =>
    (props.position as unknown) === 'LEFT' &&
    css`
      left: 0;
      justify-content: center;
      align-items: ${props.isSinglePage ? 'flex-start' : 'auto'};
    `}

    ${props =>
      (props.position as unknown) === 'CENTER' &&
      css`
        right: auto !important;
        left: auto;

        justify-content: center;
      `}

    ${props =>
      (props.position as unknown) === 'RIGHT' &&
      css`
        right: 0;
        justify-content: center;
        align-items: ${props.isSinglePage ? 'flex-end' : 'auto'};
      `}

  ${props =>
    (props.position as unknown) === 'BOTTOM_LEFT' &&
    css`
      left: 0;
      justify-content: end;
      align-items: ${props.isSinglePage ? 'flex-start' : 'auto'};
    `}


  ${props =>
    (props.position as unknown) === 'BOTTOM_CENTER' &&
    css`
      justify-content: end;
    `}


  ${props =>
    (props.position as unknown) === 'BOTTOM_RIGHT' &&
    css`
      right: 0;
      justify-content: end;
      align-items: ${props.isSinglePage ? 'flex-end' : 'auto'};
    `}
`;

export const StyledGlenardenWrapper = styled.div<{
  delay: number;
  isSinglePage?: boolean;
  heightPercentage: number;
}>`
  z-index: ${ZINDEX.super};
  animation: ${show} ${props => props.delay}s;
  position: absolute;
  bottom: 0;
  height: ${props => props.heightPercentage}%;

  display: flex;
  justify-content: center;
  ${props =>
    props.isSinglePage &&
    css`
      position: absolute;

      top: 50%;
      left: 30%;
    `}
`;

export const StyledViallTopRightWrapper = styled(StyledOverlayWrapper)`
  right: 0;
`;

export const StyledViallBottomLeftWrapper = styled(StyledOverlayWrapper)`
  left: 0;

  justify-content: flex-end;
`;
